// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__I20Wo","resendInfoText":"OnGoingPaymentBox_resendInfoText__1lRuC"};